import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { externalLinkOpen } from '../../../../actions/externallink';
import { RedirectServices, getRedirectUrl } from '../../../../config/urls';
import useMergeProps from '../../../../hooks/useMergeProps';
import { selectEntitiesMissionsEntityRulesUrl } from '../../../../selectors/entities/missions/entitiesMissionsPrimary.selector';
import { StateType } from '../../../../states';

import MissionDetailsRulesButton from './MissionDetailsRulesButton';

type MissionDetailsRulesButtonContainerProps = {
  className?: string;
  missionId: number;
};

const MissionDetailsRulesButtonContainer = ({ missionId, ...ownProps }: MissionDetailsRulesButtonContainerProps) => {
  const dispatch = useDispatch();
  const selectorProps = useMemo(() => ({ missionId }), [missionId]);
  const missionRulesURL = useSelector((state: StateType) => selectEntitiesMissionsEntityRulesUrl(state, selectorProps));

  const onClick = useCallback(() => {
    dispatch(
      externalLinkOpen(getRedirectUrl(RedirectServices.ENCODED_URL, { url: missionRulesURL }), {
        external: true,
      }),
    );
  }, [dispatch, missionRulesURL]);

  const otherProps = useMemo(
    () => ({
      onClick,
    }),
    [onClick],
  );

  const enhancedProps = useMergeProps({ ownProps, otherProps });

  return missionRulesURL ? <MissionDetailsRulesButton {...enhancedProps} /> : null;
};

export default MissionDetailsRulesButtonContainer;
